import { useNavigate } from "react-router-dom"
import { ALERT_TYPE, OPERATION_MODE, ShowToastMessage, TRIBUTO_TYPE } from '@laramie/ui';
const getPathByTipoTributo = (idTipoTributo, idTributo) => {
    switch (idTipoTributo) {
        case TRIBUTO_TYPE.INMUEBLES: return `/inmueble/${OPERATION_MODE.VIEW}/${idTributo}`
        case TRIBUTO_TYPE.COMERCIOS: return `/comercio/${OPERATION_MODE.VIEW}/${idTributo}`
        case TRIBUTO_TYPE.VEHICULOS: return `/vehiculo/${OPERATION_MODE.VIEW}/${idTributo}`
        case TRIBUTO_TYPE.CEMENTERIOS: return `/cementerio/${OPERATION_MODE.VIEW}/${idTributo}`
        case TRIBUTO_TYPE.FONDEADEROS: return `/fondeadero/${OPERATION_MODE.VIEW}/${idTributo}`
        case TRIBUTO_TYPE.CUENTAS_ESPECIALES: return `/cuenta-especial/${OPERATION_MODE.VIEW}/${idTributo}`
        default: return null
    }
}


const NumeroCuentaField = ({ numeroCuenta, idTributo, idTipoTributo, onNavigate }) => {
    const navigate = useNavigate()

    const path = (idTributo > 0 && idTipoTributo > 0) ? getPathByTipoTributo(idTipoTributo, idTributo) : null

    const handleCopy = () => {
        if (numeroCuenta) {
            navigator.clipboard.writeText(String(numeroCuenta))
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'Copiado al portapapeles')
        }
    }

    const handleNavigate = () => {
        if (!path) return
        if (onNavigate) onNavigate()
        navigate(path)
    }

    return (
        <div className="wrapper">
            <input
                type="text"
                className="form-control text-truncate"
                style={{ paddingRight: numeroCuenta ? (path ? '52px' : '28px') : undefined }}
                value={numeroCuenta || ''}
                disabled={true}
                title={numeroCuenta ? String(numeroCuenta) : ''}
            />
            {numeroCuenta && (
                <>
                    <span
                        className="material-symbols-outlined icon-cruz"
                        style={{ right: path ? '26px' : '2px', fontSize: '18px' }}
                        onClick={handleCopy}
                        title="Copiar"
                    >content_copy</span>
                    {path && (
                        <span
                            className="material-symbols-outlined icon-cruz"
                            style={{ right: '2px', fontSize: '18px' }}
                            onClick={handleNavigate}
                            title="Ir a la cuenta"
                        >open_in_new</span>
                    )}
                </>
            )}
        </div>
    )
}

export default NumeroCuentaField
